<template>
  <div class="chart-avance">
    <div class="chart-avance-outter" :key="key">
      <div :class="{ 
            'chart-avance-inner': true,
            'danger': pjeAvance > 75
          }" 
          :style="{ width: pjeAvance + '%'}">
        <span :class="{ 
          'chart-avance-valor': true,
          'light': pjeAvance > 55
        }">{{ pjeAvance | numero(2, true) }}%</span>
      </div>
    </div>
    <p class="description">{{ descripcion }}</p>
  </div>

</template>

<script>
export default {
  props: {
    pjeAvance: {
      type: Number,
      default: 0
    },
    descripcion: {
      type: String,
      default: 'Tiempo transcurrido'
    }
  },
  data() {
    return {
      key: 0,

      rojo: '#E46651',
      rosa: '#FF0187',
    }
  },
  created() {
  },
  methods: {
    refresh() {
      this.key++;
    },
  }
}
</script>

<style>
  .chart-avance {
    margin-top: 5px;
    margin-bottom: 0;
  }
  .chart-avance-outter {
    width: 70%;
    left: 15%;
    height: 20px;
    background-color: #DDDDDD;
    border: 1px solid #ccc;
    position: relative;
    overflow: hidden;
    margin-bottom: 5px;
  }
  .chart-avance-inner {
    height: 100%;
    background-color: #FF0187;
    transition: width 0.3s ease;
  }
  .chart-avance-inner.danger {
    background-color: #E46651;
  }
  .chart-avance-valor {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.8em;
    font-weight: 600;
    color: rgb(35, 40, 44);
    pointer-events: none;
  }
  .chart-avance-valor.light {
    color: white;
  }
  .chart-avance p.description {
    font-size: 0.8em;
    font-style: italic;
    margin-bottom: 0;
  }
</style>


